import React from "react";
import { Navigate } from "react-router-dom";
import { auth } from "@/lib/admin/api";

export default function Protected({ children }) {
  if (!auth.isLoggedIn()) return <Navigate to="/owner-cabinet/login" replace />;
  return children;
}
